import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { authApiReq, authApiRes } from './interfaces'

class AuthApi implements apiInterface.IAuthApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  login = async (params: authApiReq.ILoginReq): Promise<authApiRes.ILoginRes> => {
    const res = await this.ctx.post<authApiReq.ILoginReq, authApiRes.ILoginRes>(
      '/auth/login/',
      params
    )
    const { data } = res
    this.ctx.setAuthToken(data.access_token)
    return data
  }

  logout = async (): Promise<void> => {
    await this.ctx.post('/auth/logout/', {})
    this.ctx.removeAuthToken()
  }
}

export default AuthApi
